// extracted by mini-css-extract-plugin
export default {"backdrop":"bYZ66ygGx9UpBCua2ZJc","main":"wGM1k9o1JBa2NS6hMSTA"};